<template>
    <section class="l2-early-adopter" id="early-adopter">
        <div class="l2-early-adopter__container">
            <div class="l2-early-adopter__header">
                <span class="l2-early-adopter__kicker">Early Adopter</span>
                <h2 class="l2-early-adopter__title">
                    Get early access.<br />
                    <span class="l2-early-adopter__title-accent">Help shape what we build next.</span>
                </h2>
                <p class="l2-early-adopter__subtitle">Join the early access list to lock in forever pricing and get launch updates. No spam.</p>
            </div>

            <div class="d-flex justify-center">
                <HeroEarlyAccessIsland />
            </div>
        </div>
    </section>
</template>

<script lang="ts" setup>
    import HeroEarlyAccessIsland from '@/pages/Landing/islands/HeroEarlyAccessIsland.vue';
</script>

<style lang="scss" scoped>
    .l2-early-adopter {
        position: relative;
        padding: var(--l2-section-padding-y) 24px;
        background: var(--l2-bg);
        border-top: 1px solid var(--l2-border-subtle);

        &__container {
            max-width: 900px;
            margin: 0 auto;
        }

        &__header {
            text-align: center;
            margin-bottom: 28px;
        }

        &__kicker {
            display: inline-block;
            font-size: 0.875rem;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.1em;
            color: var(--l2-accent);
            margin-bottom: 16px;
        }

        &__title {
            font-size: clamp(2rem, 4vw, 3rem);
            font-weight: 700;
            line-height: 1.2;
            color: var(--l2-text);
            margin-bottom: 16px;
        }

        &__title-accent {
            color: var(--landing-muted);
        }

        &__subtitle {
            font-size: 1.0625rem;
            line-height: 1.7;
            color: var(--landing-muted);
            margin: 0 auto;
            max-width: 720px;
        }
    }

    @media (max-width: 600px) {
        .l2-early-adopter {
            &__header {
                margin-bottom: 20px;
            }
        }
    }
</style>
